var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectronicproducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E5F3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.125 39V26C46.1244 25.4301 45.974 24.8703 45.6888 24.3769C45.4035 23.8835 44.9936 23.4737 44.5 23.1887L33.125 16.6887C32.6309 16.4035 32.0705 16.2533 31.5 16.2533C30.9295 16.2533 30.3691 16.4035 29.875 16.6887L18.5 23.1887C18.0064 23.4737 17.5965 23.8835 17.3112 24.3769C17.026 24.8703 16.8756 25.4301 16.875 26V39C16.8756 39.5699 17.026 40.1297 17.3112 40.6231C17.5965 41.1165 18.0064 41.5263 18.5 41.8112L29.875 48.3112C30.3691 48.5965 30.9295 48.7467 31.5 48.7467C32.0705 48.7467 32.6309 48.5965 33.125 48.3112L44.5 41.8112C44.9936 41.5263 45.4035 41.1165 45.6888 40.6231C45.974 40.1297 46.1244 39.5699 46.125 39Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3138 24.31L31.5 32.5162L45.6862 24.31",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 48.88V32.5",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicproducts);
export default __webpack_public_path__ + "static/media/electronicproducts.d5d9f812aa740300eb8f03db4c2da43f.svg";
export { ForwardRef as ReactComponent };